import React from 'react';
import PropTypes from 'prop-types';


const getImgUrlByKorhatar = (korhatar) => {
  if(korhatar === '0') {
    return process.env.PUBLIC_URL + '/img/0_age_icon_black.svg';
  } else if(korhatar === '1') {
    return process.env.PUBLIC_URL + '/img/0_age_icon_black.svg';
  } else if(korhatar === '6') {
    return process.env.PUBLIC_URL + '/img/6_age_icon_black.svg';
  } else if(korhatar === '12') {
    return process.env.PUBLIC_URL + '/img/12_age_icon_black.svg';
  } else if(korhatar === '16') {
    return process.env.PUBLIC_URL + '/img/16_age_icon_black.svg';
  } else if(korhatar === '18') {
    return process.env.PUBLIC_URL + '/img/18_age_icon_black.svg';
  } else if(korhatar === 'x' || korhatar === 'X') {
    return process.env.PUBLIC_URL + '/img/x_age_icon_black.svg';
  } else {
    return process.env.PUBLIC_URL + '/img/0_age_icon_black.svg';
  }
}

const KorhatarItem = (props) => {
  return (
    <img
      src={getImgUrlByKorhatar(props.value)}
      style={{
        height: 25,
        width: 25,
        // display: 'block',
      }}
      alt={props.value}
    />
  );
};

KorhatarItem.defaultProps = {
  value: '-',
};

KorhatarItem.propTypes = {
  value: PropTypes.string,
};

export default KorhatarItem;